import type { SVGProps } from "react";

export function IconBlueChatbubbleSmile(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7 19C7 12.3726 12.3726 7 19 7H45C51.6274 7 57 12.3726 57 19V36.964C57 42.4704 53.2524 47.2702 47.9104 48.6057L46.3333 49L55.6667 57H19C12.3726 57 7 51.6274 7 45V19Z"
        fill="#5486FA"
        stroke="#5486FA"
        strokeWidth="1.5"
      />
      <circle
        cx="32"
        cy="32"
        r="12"
        fill="white"
        stroke="white"
        strokeWidth="1.5"
      />
      <path
        d="M25.5 32C25.5 33.7239 26.1848 35.3772 27.4038 36.5962C28.6228 37.8152 30.2761 38.5 32 38.5C33.7239 38.5 35.3772 37.8152 36.5962 36.5962C37.8152 35.3772 38.5 33.7239 38.5 32"
        stroke="#1C1719"
        strokeWidth="1.5"
      />
    </svg>
  );
}
